// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectAreSimilarStockCarsAvailable } from 'src/app/store/common/common.selectors';

import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

/**
 * Resolver which requires the compare teaser component to be loaded, also see IsSimilarStockCarsAvailableAtAllResolver
 */
@Injectable()
export class IsSimilarStockCarsAvailableResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsSimilarStockCarsAvailable;

  public constructor(private readonly store: Store) {}

  public resolve$(): Observable<boolean> {
    return this.store.select(selectAreSimilarStockCarsAvailable);
  }
}
